import React, { useMemo } from 'react';
import { getZoomTransform } from '../../../utils/zoomPosition';

// Lightweight preview that visually matches the in-game zoom effect:
// - square container with overflow hidden
// - centered <img> whose box scales with zoomLevel%
// - zoomOrigin shifts the view to match the in-game random offset
export default function ZoomedImagePreview({
  imageUrl,
  alt = 'Zoomed image preview',
  zoomLevel = 100,
  zoomOrigin = null,
  size = 220,
  borderRadius = 10,
}) {
  const z = Number.isFinite(Number(zoomLevel)) ? Number(zoomLevel) : 100;

  const transform = useMemo(
    () => getZoomTransform(zoomOrigin, z),
    [zoomOrigin, z]
  );

  if (!imageUrl) return null;

  return (
    <div
      style={{
        width: size,
        height: size,
        flexShrink: 0,
        overflow: 'hidden',
        borderRadius,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#1a1a1b',
        border: '1px solid #3a3a3c',
      }}
    >
      <img
        src={imageUrl}
        alt={alt}
        style={{
          width: `${z}%`,
          height: `${z}%`,
          objectFit: 'cover',
          transform,
          maxWidth: 'none',
          maxHeight: 'none',
          display: 'block',
        }}
      />
    </div>
  );
}

